import React, { useEffect, useState } from "react";
import Moment from "react-moment";
import axios from "axios";
import "./posts.css";
import { NavLink } from "react-router-dom";
import ShowMore from "react-show-more";
import MediaRender from "../S3Media/MediaRender";

const PostList = () => {
  let [user] = useState(JSON.parse(localStorage.getItem("user")));
  const [languages, setlanguages] = useState([]);
  const [posts, setPosts] = useState([]);
  const [pages, setPages] = useState({ page: 1, size: 20 });
  const [paging, setPaging] = useState(true);
  const [message, setMessage] = useState({
    type: null,
    text: "",
  });
  const [post, setPost] = useState({
    language: user.language,
  });

  const nextPage = () => {
    loadPaging(pages.page + 1, pages.size);
    setPages((prevState) => {
      return {
        ...prevState,
        page: prevState.page + 1,
      };
    });
  };
  const handleChange = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;

    setPost((prevState) => {
      return {
        ...prevState,
        [name]: value,
      };
    });
  };

  const approvePost = async (postid) => {
    //e.preventDefault();
    let error = false;

    if (!eval("post" + "." + "is_plag_" + postid)) {
      error = true;
      setMessage(() => {
        return {
          type: "danger",
          message: "Please select Plagarism.",
        };
      });
      return;
    }
    if (!eval("post" + "." + "remarks_" + postid)) {
      error = true;
      setMessage(() => {
        return {
          type: "danger",
          message: "Please enter Post remarks.",
        };
      });
      return;
    }

    if (!eval("post" + "." + "is_plag_" + postid) === "1") {
      if (!eval("post" + "." + "link_" + postid)) {
        error = true;
        setMessage(() => {
          return {
            type: "danger",
            message: "Please enter Post Link.",
          };
        });
        return;
      }
    }

    if (!error) {
      //let intitemid = e.target.id.replace("item-", "");

      await axios
        .put(
          localStorage.getItem("basurl") + "/posts/status",
          {
            id: postid,
            link: eval("post" + "." + "link_" + postid),
            is_plag: eval("post" + "." + "is_plag_" + postid),
            remarks: eval("post" + "." + "remarks_" + postid),
          },
          { headers: { "mojo-access-tokens": user.token } }
        )
        .then((response) => {
          loadPaging(pages.page, pages.size);
          post.link = "";
          post.is_plag = -1;
          setMessage(() => {
            return {
              type: "success",
              message: response.data.message,
            };
          });
        })
        .catch((error) => {
          setMessage(() => {
            return {
              type: "danger",
              message: error.response.data.message,
            };
          });
        });
    }
  };

  const loadPaging = async (page, size = pages.size) => {
    let user = JSON.parse(localStorage.getItem("user"));
    try {
      await axios
        .get(
          localStorage.getItem("basurl") +
            "/posts?page=" +
            page +
            "&size=" +
            size +
            "&lang=" +
            post.language,
          {
            headers: {
              "mojo-access-tokens": user.token,
            },
          }
        )
        .then((response) => {
          setPosts(response.data);
          //   setPosts((prevState) => {
          //     prevState.push.apply(prevState, response.data);
          //     return [...prevState];
          //   });
          if (response.data.length < size) {
            setPaging(false);
          }
        })
        .catch((error) => {
          if (
            typeof error.response.data !== undefined &&
            error.response.data.loginRequired
          ) {
            localStorage.removeItem("user");
            window.location.href = "/login";
          }
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const resetMessage = (e) => {
    setMessage(() => {
      return {
        type: null,
        message: "",
      };
    });
  };

  const getMessage = () => {
    if (message.type) {
      return (
        <div className={`alert alert-${message.type}`} role="alert">
          <button type="button" className="close" onClick={resetMessage}>
            <span aria-hidden="true">&times;</span>
          </button>
          <strong className="d-block d-sm-inline-block-force">
            {message.type === "success" ? "Well done!" : "Oops!"}
          </strong>{" "}
          {message.message}
        </div>
      );
    }
  };

  const getUserLanguage = async () => {
    try {
      console.log(user);
      await axios
        .get(localStorage.getItem("basurl") + "/userlanguages", {
          headers: {
            "mojo-access-tokens": user.token,
          },
        })
        .then((response) => {
          setlanguages(response.data);
        })
        .catch((err) => {
          setMessage(() => {
            return {
              type: "danger",
              message: err.response.data.message,
            };
          });
        });
    } catch (err) {
      setMessage(() => {
        return {
          type: "danger",
          message: err.message,
        };
      });
    }
  };

  useEffect(() => {
    loadPaging(1);
    getUserLanguage();
  }, [post.language]);

  return (
    <>
      {getMessage()}
      <br />

      <div className="mg-t-8">
        <>
          <div className="row">
            <label className="col-sm-3 form-control-label">
              &nbsp;Language: <span className="tx-danger">*</span>
            </label>
            <div className="col-sm-4 mg-t-5 mg-sm-t-0">
              <select
                id="language"
                name="language"
                onFocus={resetMessage}
                onChange={handleChange}
                placeholder="Please choose your language"
                className="form-control"
                value={post.language}
                defaultValue={0}
              >
                {languages.map((lang) => (
                  <option
                    key={`lang` + lang.id}
                    value={lang.id}
                    selected={lang.id === post.language ? true : false}
                  >
                    {lang.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
          {posts.length ? (
            posts.map((item) => (
              <div key={`media${item.id}`} className="media pd-5 pd-xs-5">
                {user.profile_pic ? (
                  <>
                    <img
                      src={`${localStorage.getItem("basurl")}/uploads/${
                        user.profile_pic
                      }`}
                      alt="User"
                      className="wd-40 rounded-circle"
                    />
                  </>
                ) : (
                  <>
                    <span
                      className="wd-32 rounded-circle tx-bold tx-16"
                      style={{
                        border: "1px solid #ccc",
                        padding: "3px 11px",
                      }}
                    >
                      {item.createdby.charAt(0).toUpperCase()}
                    </span>
                  </>
                )}
                <div key={item.id} className="media-body mg-l-5">
                  <div className="d-flex justify-content-between mg-b-5">
                    {user.role === "Editor" || (user.role === "Admin") === 1 ? (
                      <span>
                        {item.createdby}: {item.city} ({item.state})
                      </span>
                    ) : (
                      ""
                    )}
                    <span className="tx-12 tx-success">
                      <Moment date={item.created_at1} local fromNow />
                    </span>
                  </div>
                  <h6 className="mg-b-10 mg-t-8 tx-inverse tx-16">
                    {item.title}
                    {item.status === "P" ? (
                      <span className="ft-right tx-12">
                        <a
                          href={item.link}
                          target="_blank"
                          className="btn-sm alert-info"
                        >
                          Link
                        </a>
                      </span>
                    ) : (
                      ""
                    )}
                    {item.status === "R" ? (
                      <span className="ft-right btn-sm alert-danger">
                        Rejected.
                      </span>
                    ) : (
                      ""
                    )}
					{(item.status === "C" || item.is_plag === 1) ? (
                      <span className="ft-right btn-sm alert-danger">
                        Copied.
                      </span>
                    ) : (
                      ""
                    )}
                  </h6>
                  <div className="row">
                    {item.medias.map((media) => (
                      <div
                        className="col-md-3 col-sm-4"
                        key={`media-${media.media_id}`}
                      >
                        {<MediaRender data={media} rclass="img-fluid" />}
                      </div>
                    ))}
                  </div>
                  <div className="mg-b-20 display-linebreak tx-14 mg-t-8">
                    <ShowMore lines={3} more="Show more" less="Show less">
                      {item.description}
                    </ShowMore>
                  </div>
                  <div className="ft-right tx-20">
                    {user.role === "Editor" ||
                    (user.role === "Admin" && !item.status) ? (
                      <div>
                        <select
                          id="post-Plag"
                          name={"is_plag_" + item.id}
                          className="tx-12 mg-x-5"
                          onChange={handleChange}
                        >
                          <option value={-1}>--select plagarism</option>
                          <option value={0}>Post not Copied</option>
                          <option value={1}>Post Copied</option>
                        </select>{" "}
                        <input
                          type="text"
                          name={"remarks_" + item.id}
                          onFocus={resetMessage}
                          className="tx-12 mg-x-5"
                          placeholder="enter remarks"
                          defaultValue={item.remarks}
                          onChange={handleChange}
                        />{" "}
                        <input
                          type="text"
                          name={"link_" + item.id}
                          onFocus={resetMessage}
                          className="tx-12 mg-x-5"
                          placeholder="enter post link"
                          defaultValue={item.link}
                          onChange={handleChange}
                        />
                        <i
                          className="tx-success mg-x-5 ion-android-checkbox-outline"
                          id={`item-${item.id}`}
                          onClick={approvePost.bind(this, item.id)}
                        ></i>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="media-footer">
                    <div>
                      {item.created_by === user.id && !item.status ? (
                        <NavLink
                          to={`/posts/update-post/${item.id}`}
                          className="mg-l-10"
                        >
                          Edit Post
                        </NavLink>
                      ) : (
                        ""
                      )}

                      {item.status ? (
                        <span className="tx-10 mg-r-10">
                          <b>
                            {item.status === "P" ? "Published " : ""}
                            {item.status === "R" ? "Rejected " : ""}
                          </b>
                          &nbsp;by <b>{item.statusby}</b>
                          <Moment
                            className="mg-x-10"
                            date={item.status_at1}
                            local
                            fromNow
                          />
                          |<b className="mg-l-10">Remarks:</b>{" "}
                          <span className=" pd-x-4">{item.remarks}</span>
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="media pd-20 pd-xs-30">
              <span className="tx-center">
                You have not added any post yet.
              </span>
            </div>
          )}
        </>
        <div className="card-footer tx-10 pd-y-15 bg-transparent tx-center">
          {paging ? (
            <h4 onClick={nextPage} href="#" className="pointer tx-16">
              <i className="fa fa-angle-down mg-r-5" />
              View More
            </h4>
          ) : (
            <></>
          )}
        </div>
      </div>
    </>
  );
};

export default PostList;
